import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import type { SalaryDistributionAnalyticalFeatureSettingsFormInterface } from '@zaoblako/shared/modules/document/dtos/salary-distribution/form/salary-distribution-analytical-feature-settings-form.interface';
import type { UnitFindInterface } from '@zaoblako/shared/modules/catalog/dtos/unit/unit-find.dto';

import * as yup from 'yup';

/** Unit settings for salary distribution */
export type SalaryDistributionUnitSettingsFormInterface = SalaryDistributionAnalyticalFeatureSettingsFormInterface<UnitFindInterface>;

/** Unit settings for salary distribution - DTO schema */
export const SalaryDistributionUnitSettingsFormDto = SerdeDtoClass.create<SalaryDistributionUnitSettingsFormInterface>(
  DocumentDtoKeysEnum.SALARY_DISTRIBUTION_UNIT_SETTINGS_FORM_DTO,
  {
    distribute: {
      label: 'Распределить',
      serializer: yup.boolean(),
    },
    target: {
      label: 'БЕ',
      optional: true,
      checkers: [CatalogCheckersEnum.UNIT_ASSERT_EXISTS_BY_DTO],
      serializer: (): yup.Schema<any> => yup.object({
        id: yup
          .number()
          .positive(DtoMessageEnum.NOT_POSITIVE)
          .integer(DtoMessageEnum.NOT_INTEGER),
      }),
    },
  },
);
